import { createReducer, createActions } from 'reduxsauce';
import update from 'immutability-helper';
import type { InvoiceJustifications } from 'contracts/Invoice';

const { Types, Creators } = createActions(
  {
    request: ['query', 'onSuccess', 'onFailure'],
    success: ['data'],
    failure: ['errorMessage'],
    softReset: [],
    reset: [],
  },
  {
    prefix: 'LIST_INVOICEJUSTIFICATIONS_',
  }
);

export interface ListInvoiceJustificationsState {
  data: InvoiceJustifications[];
  loading: boolean;
  errorMessage: string | null;
}

export interface ListInvoiceJustificationsRequestAction {
  query?: Record<string, any>;
  onSuccess?: () => void;
  onFailure?: () => void;
}

interface SuccessAction {
  data: InvoiceJustifications[];
}

interface FailureAction {
  errorMessage: string;
}

const INITIAL_STATE: ListInvoiceJustificationsState = {
  data: [],
  loading: false,
  errorMessage: null,
};

const request = (state: ListInvoiceJustificationsState) =>
  update(state, {
    loading: { $set: true },
    errorMessage: { $set: null },
  });

const success = (state: ListInvoiceJustificationsState, action: SuccessAction) =>
  update(state, {
    loading: { $set: false },
    data: { $set: action.data },
  });

const failure = (state: ListInvoiceJustificationsState, action: FailureAction) =>
  update(state, {
    loading: { $set: false },
    errorMessage: { $set: action.errorMessage },
  });

const softReset = (state: ListInvoiceJustificationsState) =>
  update(state, {
    loading: { $set: false },
  });

const reset = () => INITIAL_STATE;

export const listInvoiceJustifications = createReducer(INITIAL_STATE, {
  [Types.REQUEST]: request,
  [Types.SUCCESS]: success,
  [Types.FAILURE]: failure,
  [Types.SOFT_RESET]: softReset,
  [Types.RESET]: reset,
});

export const ListInvoiceJustificationsTypes = Types;
export const ListInvoiceJustificationsActions = Creators;
